import { render } from "./AccountSubmittedView.vue?vue&type=template&id=fa852eb4"
import script from "./AccountSubmittedView.vue?vue&type=script&lang=js"
export * from "./AccountSubmittedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__